import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { push } from 'connected-react-router'

import MainView from '../components/MainView/MainView'

// import { setCMSMalls } from '../../../modules/dashboard/actions/creators'

import {
  waitRenderServer,
  renderServer,
} from '../../../modules/ssr/actions/creators'

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      // setCMSMalls,
      push,
      waitRenderServer,
      renderServer,
    },
    dispatch,
  )

const ConnectedMainView = connect(null, mapDispatchToProps)(MainView)

export default ConnectedMainView
